import {FormGroup} from "@angular/forms";

const debug = false;

export function IdentityNumberValidator(identityNumber: string, formSubmitted: boolean, errorElementName: string) {
    return (formGroup: FormGroup) => {
        if (errorElementName && formGroup.controls[errorElementName]) {
            const errorElement = formGroup.controls[errorElementName];
            errorElement.setErrors(null);

            if (formSubmitted) {
                if (identityNumber === null || identityNumber === undefined || identityNumber.length === 0) {
                    errorElement.setErrors({ invalid: true });
                } else {
                    if (!validateRSAIDNumber(identityNumber)) {
                        log('identityNumber [' + identityNumber + '] is invalid!');
                        errorElement.setErrors({ invalid: true });
                    }
                }
            }
        }
        return null;
    };
}

export function isNumber(n): boolean {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export function validateRSAIDNumber(idnumber: string): boolean {
    let invalid = 0;

    // check that value submitted is a number
    if (!isNumber(idnumber)) {
        log('ERROR [1]');
        invalid++;
    }

    // check length of 13 digits
    if (idnumber.length !== 13) {
        log('ERROR [2]');
        invalid++;
    }

    // check that YYMMDD group is a valid date
    const yy = Number(idnumber.substring(0, 2));
    const mm = Number(idnumber.substring(2, 4));
    const dd = Number(idnumber.substring(4, 6));

    const dob = new Date(yy, (mm - 1), dd);

    // check values - add one to month because Date() uses 0-11 for months
    if (!(((dob.getFullYear() + '').substring(2, 4) === yy.toString(10)) && (dob.getMonth() === mm - 1) && (dob.getDate() === dd))) {
        log('ERROR [3]');
        invalid++;
    }

    // evaluate GSSS group for gender and sequence
    const gender = parseInt(idnumber.substring(6, 10), 10) > 5000 ? 'M' : 'F';

    // ensure third to last digit is a 1 or a 0
    if (Number(idnumber.substring(10, 11)) > 1) {
        log('ERROR [4]');
        invalid++;
    }

    // ensure second to last digit is a 8 or a 9
    if (Number(idnumber.substring(11, 12)) < 8) {
        log('ERROR [5]');
        invalid++;
    }

    // calculate check bit (Z) using the Luhn algorithm
    let ncheck = 0;
    let beven = false;

    for (let c = idnumber.length - 1; c >= 0; c--) {
        const cdigit = idnumber.charAt(c);
        let ndigit = parseInt(cdigit, 10);

        if (beven) {
            if ((ndigit *= 2) > 9) ndigit -= 9;
        }

        ncheck += ndigit;
        beven = !beven;
    }

    if ((ncheck % 10) !== 0) {
        log('ERROR [6]');
        invalid++;
    }

    return !invalid;
}

export function log(text: string): void {
    if (debug) {
        console.log(text);
    }
}
